import { useState } from "react"
import { useLayoutData } from "../../../../../../utils/contexts/LayoutContext"
import { topBarHasRightData } from "../../../../PartnerPortalLayout"
import Header from "../Header/Header"
import TopBar from "../TopBar/TopBar"
import Menu from "./Menu"
import MobilNavbar from "./MobilNavbar"

const Navbar = () => {
  const { partnerSiteFull } = useLayoutData()
  const [mobilMenuOpen, setMobilMenuOpen] = useState<boolean>(false)

  return (
    <>
      <div className={`header-area header-sticky header-sticky--default`}>
        <div className={'header-area__desktop header-area__desktop--default'}>
          {topBarHasRightData(partnerSiteFull) ? (
            <TopBar />
          ) : null}
          <Header openMobilMenu={() => setMobilMenuOpen(true)} />
          <Menu />
        </div>
      </div>
      <MobilNavbar open={mobilMenuOpen} close={() => setMobilMenuOpen(false)} />
    </>
  )
}

export default Navbar